import { List } from "immutable"
import { Link } from "../library/link"
import { Teasers } from "../teaser"
import { RecentNewsBlockLayoutProps } from "./recentNewsBlockState"
import React = require("react")

export const RecentNewsBlockLayout = (props: RecentNewsBlockLayoutProps) => {
  const items = props.items.kind == 'loaded' ? props.items.value : []

  return (
    <section className="block block--content-grid container--lg align--center" key={props.key}>
      {(props.title && props.title != "") && (
        <header className="block__header container--m align--center">
          <h2 className="block__title title--l container--xs">{props.title}</h2>
        </header>
      )}

      <Teasers items={List(items)} />

      {(props.linkTitle && props.linkUrl) && (
        <footer className="block__actions container--m align--center">
          <Link className="button button--primary button--arrow" url={props.linkUrl}>
            <span className="button__label">{props.linkTitle}</span>
          </Link>
        </footer>
      )}
    </section>
  )
}